<lib-elux-modal [open]="true" (onClose)="cancel.emit()">
  <div modal-header>
    <h1 class="heading-1 c-blue">Tem certeza que deseja sair sem salvar?</h1>
  </div>
  <div modal-body class="text d-flex flex-column">
    <span class="body mt-4">
      Você realizou alterações nesta página. Se sair agora, todas as mudanças serão descartadas. Deseja continuar sem
      salvar?
    </span>
  </div>
  <div modal-footer>
    <div class="d-row">
      <lib-elux-button class="me-7" [content]="'Cancelar'" [type]="'text'" (click)="cancel.emit()" />
      <lib-elux-button [content]="'Sair sem salvar'" [type]="'basic'" (click)="confirm.emit()" />
    </div>
  </div>
</lib-elux-modal>
